<template lang="pug">
  a.gw-headline__dropdown-item(:href="getHref" :target="getTarget" @click="click($event)")
    span {{ link.title }}
</template>

<script>
export default {
  name: "MyGamesHeadlineNavigation",

  props: {
    link: Object,
  },
  computed: {
    getHref() {
      return this.link.url ? this.link.url : "javascript:;";
    },
    getTarget() {
      return this.link.blank ? "_blank" : "_self";
    },
  },
  methods: {
    click(event) {
      if (this.link.callback) {
        this.link.callback();
        event.preventDefault();
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>
